import { useContext, useState,} from 'react'
import './TopUne.css'
import Toggle from '../../../../../components/Toggle/Toggle'
import { DashboardContext } from '../../../../../Hooks/DashboardContext'
import { UpdateDoc } from '../../../../../firebase/utils'

const TopUne = ({TopUneDetails}) => {

  const device='xaf'
   const {CurrentBannerNumber,setCurrentBannerNumber,MaxBannerNumber}=useContext(DashboardContext)
   const [isChecked,setIschecked]=useState(TopUneDetails.isChecked)

 const HandleTopUnerToggle=(CurrentToggle)=>{

    let newBannerNumber = CurrentBannerNumber;
     
    const isCurrentlyChecked = CurrentToggle.classList.contains('checked');

    if(isCurrentlyChecked) {

      CurrentToggle.classList.remove('checked')
      if(newBannerNumber>0) {
      newBannerNumber -=1
      }
    }
    else {

      CurrentToggle.classList.add('checked')
      if(newBannerNumber<MaxBannerNumber) {
        newBannerNumber +=1
      }
      else {

        CurrentToggle.classList.add('checked');
        setTimeout(() => {
          CurrentToggle.classList.remove('checked');
        }, 500);
        return;
      }
     
    }

    setCurrentBannerNumber(newBannerNumber)

   



  }
   const HandleTopUneToggle=()=>{
  
      if (isChecked) {
  
        UpdateDoc("TopUnes",TopUneDetails.id,{...TopUneDetails,isChecked:false})
        setIschecked(false)
     
      }
      else {
        
       UpdateDoc("TopUnes",TopUneDetails.id,{...TopUneDetails,isChecked:true})
       setIschecked(true)
  
      }
  
    }
  

  return (
    <div className='TopUneCard'>
      <div className='Image'>
        <img src={TopUneDetails.imgUrl} alt="" />
      </div>
      <div className='TopUneText'>
        
        <div className='Nom'>{TopUneDetails.Nom}</div>
        <div className='Prix'>{TopUneDetails.Prix} <span>{device}</span></div>

        <div className="ToggleContainer">
          <Toggle isChecked={isChecked}  HandleToggle={HandleTopUneToggle}/>
        </div>

      </div>
    </div>
  )
}

export default TopUne